import Http from 'services/Http';
import store from 'store';
import authCompanyId from 'store/selectors/authCompanyId';
import computeContentMd5Base64 from 'utils/computeContentMd5Base64';
import parseFileName from 'utils/getFileExtension';

class SharedFile {
  async upload(folderId, file, onUploadProgress, getCancelFunc, fileName) {
    const companyId = authCompanyId(store.getState());
    if (!companyId) {
      throw new Error('No company');
    }
    const { type: mimeType } = file;
    const name = fileName || file.name;
    const { ext } = parseFileName(name);
    const contentMd5 = await computeContentMd5Base64(file);
    const {
      data: { id, url },
    } = await Http.post(`/v1/shared-file/${folderId}/sign-url`, {
      mimeType,
      ext,
      folderId,
      contentMd5,
    });
    await Http.putS3(url, file, {
      headers: {
        'Content-Type': mimeType,
        'Content-MD5': contentMd5,
        // Note: x-amz-tagging is already in the presigned URL query string
        // Cache-Control is not required and not signed
        // Content-Length is set automatically by the browser
      },
      timeout: 0,
      onUploadProgress,
      getCancelFunc,
    });
    const response = await Http.patch(`/v1/shared-file/${folderId}/sign-url/uploaded`, {
      id,
      name,
      folderId,
    });
    return response.data;
  }
}

export default new SharedFile();
